import * as React from "react";
import * as $ from "jquery";
import * as _ from "lodash";
import IStaticDataValue from "../../../common/models/IStaticDataValue";
import {AppConstants, AppPlaceholders} from "../utils/AppConstants";
import {ChangeEvent} from "react";
import TypeAhead, { TypeAheadElement } from "./TypeAhead";
import AppUtils from "../utils/AppUtils";

const frequencyTypeAheadSuggestions: IStaticDataValue[] = [
    {displayValue: "per hour", internalValue: AppConstants.FrequencyUnit.HOUR, suggestByDefault: true},
    {displayValue: "per day", internalValue: AppConstants.FrequencyUnit.DAY, suggestByDefault: true},
    {displayValue: "per week", internalValue: AppConstants.FrequencyUnit.WEEK, suggestByDefault: true},
    {displayValue: "per month", internalValue: AppConstants.FrequencyUnit.MONTH, suggestByDefault: true},
    {displayValue: "per year", internalValue: AppConstants.FrequencyUnit.YEAR, suggestByDefault: true},
    {displayValue: "/ hour", internalValue: AppConstants.FrequencyUnit.HOUR, suggestByDefault: false},
    {displayValue: "/ day", internalValue: AppConstants.FrequencyUnit.DAY, suggestByDefault: false},
    {displayValue: "/ week", internalValue: AppConstants.FrequencyUnit.WEEK, suggestByDefault: false},
    {displayValue: "/ month", internalValue: AppConstants.FrequencyUnit.MONTH, suggestByDefault: false},
    {displayValue: "/ year", internalValue: AppConstants.FrequencyUnit.YEAR, suggestByDefault: false}
]

const durationTypeAheadSuggestions: IStaticDataValue[] = [
    {displayValue: "hour", internalValue: AppConstants.FrequencyUnit.HOUR, suggestByDefault: true},
    {displayValue: "day", internalValue: AppConstants.FrequencyUnit.DAY, suggestByDefault: true},
    {displayValue: "week", internalValue: AppConstants.FrequencyUnit.WEEK, suggestByDefault: true},
    {displayValue: "month", internalValue: AppConstants.FrequencyUnit.MONTH, suggestByDefault: true},
    {displayValue: "year", internalValue: AppConstants.FrequencyUnit.YEAR, suggestByDefault: true}
]

export interface DurationComponentProps {
    keyName?: string,
    widgetName?: string,
    disabled?: boolean,
    unit: string,
    count: string | number,
    dropdownItems?: IStaticDataValue[],
    rootClass: string,
    onCountChange?: (event: ChangeEvent<HTMLInputElement>) => any,
    onUnitChange?: (value: string) => any,
    onDurationChange?: (elem: TypeAheadElement) => any,
    placeholder?: string,
    isFrequency?: boolean,
    validator?: any,
    supportDecimal?: boolean,
    useDropdownValue?: boolean,
    validationText?: string
}

export interface DurationComponentState {
    unit: number,
    count: string,
    inputText: string,
    autoCompleteText: string
}

class DurationComponent extends React.Component<DurationComponentProps, DurationComponentState> {
    private durationTypeAheadDOM: any;
    constructor(props: DurationComponentProps) {
        super(props);
        let inputText = (_.isEmpty(props.unit) || props.unit === "SOS")
        && (_.isNull(props.count) || props.count === undefined  || props.count.toString() === "0" || props.count.toString() === "")
        ? null
        : props.count + " " + AppConstants.FrequencyUnit[props.unit];
        if (!_.isNull(inputText) && props.isFrequency) inputText = inputText.replace(" ", " / ")
        this.state = {
            unit: null,
            count: null,
            inputText,
            autoCompleteText: inputText
        }
    }

    onDurationInputChange = (input: string) => {
        let frequencySuggestions: TypeAheadElement[] = [];
        this.setState({inputText: input});
        const regexToTest = this.props.supportDecimal ? /^\d+(\.\d*)?/ : /^\d/;
        const regexToReplace = this.props.supportDecimal ? /[0-9]+(\.[0-9]*)?/g : /[0-9]/g;

        if (this.props.isFrequency !== undefined && this.props.isFrequency) {
            if (regexToTest.test(input)) {
                let withoutNumbers = input.replace(regexToReplace, "").trim();
                if (!_.isEmpty(withoutNumbers)) {
                    _.map(frequencyTypeAheadSuggestions, (frequencyItem) => {
                        if (frequencyItem.displayValue.toLowerCase().indexOf(withoutNumbers.toLowerCase()) !== -1) {
                            const inputValue = this.props.supportDecimal ? input.match( /^[0-9]+(\.[0-9]+)?/g)[0] : input.replace( /[^0-9]/g, "");
                            let typeAheadElement: TypeAheadElement = {
                                value: _.findKey(AppConstants.FrequencyUnit, (item) => (item.indexOf(frequencyItem.internalValue) !== -1)),
                                label: `${inputValue} ${frequencyItem.displayValue}`,
                                others: {
                                    type: "frequency",
                                    value: { count: inputValue,
                                        unit: _.findKey(AppConstants.FrequencyUnit, (item) => (item.indexOf(frequencyItem.internalValue) !== -1))
                                    }
                                }
                            }
                            frequencySuggestions.push(typeAheadElement);
                        }
                    })
                } else {
                    let filteredSuggestions = frequencyTypeAheadSuggestions.filter(item => item.suggestByDefault === true);
                    const inputValue = this.props.supportDecimal ? input.match( /^[0-9]+(\.[0-9]+)?/g)[0] : input.replace( /[^0-9]/g, "");
                    _.map(filteredSuggestions, (frequencyItem) => {
                        let typeAheadElement: TypeAheadElement = {
                            value: _.findKey(AppConstants.FrequencyUnit, (item) => (item.indexOf(frequencyItem.internalValue) !== -1)),
                            label: `${inputValue} ${frequencyItem.displayValue}`,
                            others: {
                                type: "frequency",
                                value: { count: Number(inputValue),
                                    unit: _.findKey(AppConstants.FrequencyUnit, (item) => (item.indexOf(frequencyItem.internalValue) !== -1))
                                }
                            }
                        }
                        frequencySuggestions.push(typeAheadElement);
                    })
                }
            }
        } else {
            if (/^\d/.test(input)) {
                let withoutNumbers = input.replace(/[0-9]/g, "").trim();
                if (!_.isEmpty(withoutNumbers)) {
                    _.map((this.props.dropdownItems || durationTypeAheadSuggestions), (frequencyItem) => {
                        if (frequencyItem.displayValue.toLowerCase().indexOf(withoutNumbers.toLowerCase()) !== -1) {
                            const elementValue = this.props.useDropdownValue ? frequencyItem.internalValue : _.findKey(AppConstants.FrequencyUnit, (item) => (item.indexOf(frequencyItem.internalValue) !== -1));
                            let typeAheadElement: TypeAheadElement = {
                                value: elementValue,
                                label: `${input.replace( /[^0-9]/g, "")} ${frequencyItem.displayValue}`,
                                others: {
                                    type: "frequency",
                                    value: {
                                        count: input.replace( /[^0-9]/g, ""),
                                        unit: elementValue
                                    }
                                }
                            }
                            frequencySuggestions.push(typeAheadElement);
                        }
                    })
                } else {
                    let filteredSuggestions: IStaticDataValue[] = (this.props.dropdownItems || durationTypeAheadSuggestions).filter(item => item.suggestByDefault === true);
                    _.map(filteredSuggestions, (frequencyItem) => {
                        const elementValue = this.props.useDropdownValue ? frequencyItem.internalValue : _.findKey(AppConstants.FrequencyUnit, (item) => (item.indexOf(frequencyItem.internalValue) !== -1));
                        let typeAheadElement: TypeAheadElement = {
                            value: elementValue,
                            label: `${input.replace( /[^0-9]/g, "")} ${frequencyItem.displayValue}`,
                            others: {
                                type: "frequency",
                                value: {
                                    count: input.replace( /[^0-9]/g, ""),
                                    unit: elementValue
                                }
                            }
                        }
                        frequencySuggestions.push(typeAheadElement);
                    })
                }
            }
        }

        if (frequencySuggestions.length > 0) {
            this.props.onDurationChange(frequencySuggestions[0]);
            this.setState({
                autoCompleteText: frequencySuggestions[0].additionalInfoLabel
            })
        }
        else this.props.onDurationChange({ value: null, label: null, others: { value: null } });
        return Promise.resolve({options: frequencySuggestions, completed: true});
    }

    onCountTypeAheadSelect = (elem: TypeAheadElement) => {
        this.props.onDurationChange(elem);
        let unit = `${AppConstants.FrequencyUnit[elem.others.value.unit]}${!this.props.isFrequency && elem.others.value.count > 1 ? "s" : ""}`;
        let inputText = elem.others.value.count + " " + unit;
        if (this.props.isFrequency) {
            inputText = elem.others.value.count + " / " + unit;
        }
        this.setState({ inputText })
    }

    onDurationInputBlur = () => {
        if (!_.isEmpty(this.props.unit) && AppUtils.isDefined(this.props.count) && this.props.count.toString() !== "" ) {
            if (this.props.isFrequency) {
                this.setState({
                    inputText: `${this.props.count} / ${AppConstants.FrequencyUnit[this.props.unit]}`
                })
            } else {
                let unitToDisplay = AppConstants.FrequencyUnit[this.props.unit];
                let unit = this.props.count > 1 ? unitToDisplay + "s" : unitToDisplay;
                this.setState({
                    inputText: `${this.props.count} ${unit}`
                })
            }
        } else {
            this.setState({
                inputText: ""
            })
        }
    }

    componentWillReceiveProps(nextProps: DurationComponentProps) {
        if (_.isEmpty(nextProps.unit) && (_.isNull(nextProps.count) || nextProps.count === undefined || nextProps.count.toString() === ""))
            this.setState({
                inputText: null
            })
        else {
            if (!$(this.durationTypeAheadDOM).find("input").is(":focus")) {
                let inputText = (_.isEmpty(nextProps.unit)|| nextProps.unit === "SOS")
                && (_.isNull(nextProps.count) || nextProps.count === undefined || nextProps.count.toString() === "0" || nextProps.count.toString() === "")
                ? null
                : nextProps.count + " " + (AppConstants.FrequencyUnit[nextProps.unit] || "");
                if (this.props.isFrequency) inputText = inputText.replace(" ", " / ");
                else inputText = nextProps.count > 1 ? inputText + "s" : inputText;
                this.setState({
                    inputText
                })
            }
        }
    }

    getPlaceholderText() {
        if (this.props.isFrequency) return AppPlaceholders.GENERIC_FREQUENCY;
        else return AppPlaceholders.GENERIC_DURATION;
    }

    render() {
        let rootClass = this.props.rootClass;
        let placeHolder = this.props.placeholder !== undefined ? this.props.placeholder : this.getPlaceholderText();
        let inputText = this.state.inputText;
        return (
            <div>
                <div className={`${rootClass}-duration`} ref={(durationDOM) => this.durationTypeAheadDOM = durationDOM}>
                    <TypeAhead name={"frequency-count"} value={inputText || ""} inputDisabled={this.props.disabled}
                               placeholder={placeHolder}
                               widgetName={this.props.widgetName}
                               onTypeAheadChange={this.onDurationInputChange}
                               onTypeAheadSelect={this.onCountTypeAheadSelect}
                               onTypeAheadBlur={this.onDurationInputBlur}
                               validator={this.props.validator} />
                </div>
            </div>
        )
    }
}

export default DurationComponent;